import { render, staticRenderFns } from "./Inhaallessen.vue?vue&type=template&id=0639b9f1"
import script from "./Inhaallessen.vue?vue&type=script&lang=js"
export * from "./Inhaallessen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports